import { render, staticRenderFns } from "./data-management-voyage.vue?vue&type=template&id=120f657b&"
import script from "./data-management-voyage.vue?vue&type=script&lang=js&"
export * from "./data-management-voyage.vue?vue&type=script&lang=js&"
import style0 from "./data-management-voyage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports